import React, { useState, useEffect } from "react"
import { get, post, put, remove } from "../../utils/apiClient"
import toast from "react-hot-toast"
import Pagination from "../common/pagination"
import SearchInputWrapper from "../common/searchInputWrapper"
import {
  validateFaxNumberOnlyDigit,
  isEmpty,
  customSelectStyles,
  displayNetIdEmail,
  formatFaxNumber,
  prepareFinalFaxNumber,
} from "../../utils/common"
import { SquarePen, Trash2, TriangleAlert } from "lucide-react"
import Select from "react-select"

const NetIdToFaxNumberAssociation = ({ reloadQueues }) => {
  const [netIds, setNetIds] = useState([])
  const [netIdsForSelect, setNetIdsForSelect] = useState([])
  const [showPopup, setShowPopup] = useState(false)
  const [netIdToEdit, setNetIdToEdit] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [actionLoading, setActionLoading] = useState(false)
  const [netIdIdToDelete, setNetIdIdToDelete] = useState(null)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [searchText, setSearchText] = useState("")
  const [activeRowId, setActiveRowId] = useState(null)

  // Search Filter
  const filteredNetIds = netIds?.filter((netId) =>
    Object.entries(netId).some(([key, value]) =>
      key === "netId" || key === "emailAddress"
        ? value?.toString().toLowerCase().includes(searchText.toLowerCase())
        : false,
    ),
  )

  const startIdx = (currentPage - 1) * rowsPerPage
  const currentNetIds = filteredNetIds.slice(startIdx, startIdx + rowsPerPage)
  const totalPages = Math.ceil(filteredNetIds.length / rowsPerPage)

  // const currentFaxes = sortedFaxes.slice(startIdx, startIdx + rowsPerPage)
  // const totalPages = Math.ceil(filteredFaxes.length / rowsPerPage)

  useEffect(() => {
    loadNetId()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchSSOCustomers = async () => {
    try {
      const nIdForSelect = await get("/admin/sso-customers")

      setNetIdsForSelect(nIdForSelect?.filter((n) => !isEmpty(n?.customerKey))) // Filter for ...In processing
    } catch (error) {
      console.error("Failed to fetch netIds", error)
    }
  }

  const fetchNetIds = async () => {
    try {
      const data = await get("/admin/netId-fax-number-associations")

      setNetIds(data)
    } catch (error) {
      console.error("Failed to fetch netIds", error)
    }
  }

  const loadNetId = async () => {
    setLoading(true)
    await fetchNetIds()
    await fetchSSOCustomers()
    setLoading(false)
  }

  const handleAddNetId = async (data) => {
    setActionLoading(true)

    const isEdit = !!data.associationId

    try {
      if (isEdit) {
        await put(`/admin/netId-fax-number-association`, {
          associationId: data.associationId,
          netId: data.netId,
          emailAddress: data.emailAddress,
          faxNumber: data.faxNumber,
          netIdRole: data.netIdRole,
        })
      } else {
        await post("/admin/netId-fax-number-association", {
          netId: data.netId,
          faxNumber: data.faxNumber,
          netIdRole: data.netIdRole,
          emailAddress: data.emailAddress,
        })
      }

      fetchNetIds()
      reloadQueues() // Reload Left panel queues
      setShowPopup(false)
      setNetIdToEdit(null)
      toast.success(`NetId ${isEdit ? "updated" : "added"} successfully`)
    } catch (error) {
      if (
        error ===
        "The Fax Number does not exist or does not belong to the customer."
      ) {
        toast.error(
          "The fax number provided is not associated with the specified Custom Fax Manager Application ID.",
        )
      } else {
        toast.error(error)
      }
    } finally {
      setActionLoading(false)
    }
  }

  const handleDeleteNetId = async () => {
    setActionLoading(true)
    try {
      await remove(
        `/admin/netId-fax-number-association/${netIdIdToDelete.associationId}`,
      )
      fetchNetIds()
      reloadQueues() // Reload Left panel queues
      setNetIdIdToDelete(null)
      toast.success("NetId removed successfully")
    } catch (error) {
      toast.error("Something went wrong")
    } finally {
      setActionLoading(false)
    }
  }

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      {loading ? (
        <div className="loading-container-fax-list">
          <div className="loading-message">Loading...</div>
        </div>
      ) : (
        <div
          className="faxes-content"
          style={{ textAlign: "center", marginTop: "20px", width: "100%" }}
        >
          <div
            className="search-container"
            style={{
              width: "100%",
              alignItems: "end",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div className="setting-note">
              <div>
                {/* <input
                  type="text"
                  placeholder={`Search NetIds`}
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value)
                    setCurrentPage(1)
                  }}
                /> */}

                <SearchInputWrapper
                  placeholder={`Search NetIds`}
                  value={searchText}
                  onChange={(val) => {
                    setSearchText(val)
                    setCurrentPage(1)
                  }}
                  onClear={() => {
                    setSearchText("")
                    setCurrentPage(1)
                  }}
                />
              </div>
            </div>
            <button
              className="faxes-button"
              onClick={() => setShowPopup(true)}
              style={{ marginBottom: "5px" }}
            >
              + Add NetId
            </button>
          </div>
          <div className="table-container">
            <table className="faxes-table">
              <thead>
                <tr>
                  <th className="faxes-th">NetId</th>
                  <th className="faxes-th">Fax Number</th>
                  {/* <th className="faxes-th" style={{ width: "300px" }}>
                    Email
                  </th> */}
                  {/* <th className="faxes-th">Role</th> */}
                  <th
                    className="faxes-th"
                    style={{ textAlign: "center", width: "100px" }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentNetIds.length > 0 ? (
                  currentNetIds.map((netId) => (
                    <tr
                      key={netId.associationId}
                      className={`fax-item fax-action-row${activeRowId === netId.associationId ? " fax-action-active" : ""}`}
                      style={{ cursor: "unset" }}
                      onMouseEnter={() => {
                        if (activeRowId && activeRowId !== netId.associationId)
                          setActiveRowId(null)
                      }}
                    >
                      <td className="faxes-td">
                        {displayNetIdEmail(netId.netId, netId.emailAddress)}
                      </td>
                      <td className="faxes-td">
                        {formatFaxNumber(netId.faxNumber)}
                      </td>
                      {/* <td className="faxes-td">{netId.emailAddress}</td> */}
                      {/* <td className="faxes-td">{netId.netIdRole}</td> */}
                      <td className="faxes-td" style={{ textAlign: "center" }}>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setActiveRowId(netId.associationId)
                            setNetIdToEdit(netId)
                          }}
                        >
                          <SquarePen size="18" color="black" />
                        </span>
                        <span
                          style={{ cursor: "pointer", marginLeft: "10px" }}
                          onClick={() => {
                            setActiveRowId(netId.associationId)
                            setNetIdIdToDelete(netId)
                          }}
                        >
                          <Trash2 size="18" color="red" />
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="100%"
                      style={{
                        textAlign: "center",
                        padding: "10px",
                        border: "1px solid #ccc",
                      }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {filteredNetIds.length > 0 && (
            <div
              className="faxes-pagination"
              style={{
                marginTop: "8px",
                display: "flex",
                justifyContent: "end",
              }}
            >
              {filteredNetIds.length > 0 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  rowsPerPage={rowsPerPage}
                  totalRows={filteredNetIds.length}
                  onPageChange={(page) => setCurrentPage(page)}
                  onRowsPerPageChange={(count) => {
                    setRowsPerPage(count)
                    setCurrentPage(1) // Reset to first page on change
                  }}
                />
              )}
            </div>
          )}
        </div>
      )}

      {(showPopup || netIdToEdit) && (
        <NetIdForm
          onSave={handleAddNetId}
          onClose={() => {
            setShowPopup(false)
            setNetIdToEdit(null)
          }}
          netIdToEdit={netIdToEdit}
          actionLoading={actionLoading}
          netIdsForSelect={netIdsForSelect}
        />
      )}

      {netIdIdToDelete && (
        <DeleteConfirmationPopup
          onConfirm={handleDeleteNetId}
          onCancel={() => setNetIdIdToDelete(null)}
          actionLoading={actionLoading}
          netIdIdToDelete={netIdIdToDelete}
        />
      )}
    </div>
  )
}

const NetIdForm = ({
  onClose,
  onSave,
  netIdToEdit,
  actionLoading,
  netIdsForSelect,
}) => {
  const [netId, setNetId] = useState("")
  const [faxNumber, setFaxNumber] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [isWarning, setIsWarning] = useState(false)

  // Load initial data if editing
  useEffect(() => {
    if (netIdToEdit) {
      setNetId(netIdToEdit?.netId)
      setFaxNumber(netIdToEdit?.faxNumber)
    } else {
      setNetId(netIdsForSelect[0]?.netId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [netIdToEdit])

  const handleSubmit = (e, isConfirmed = false) => {
    e.preventDefault()

    if (!netId.trim()) {
      setErrorMessage("NetId is required.")
      return
    }

    if (faxNumber) {
      const errorMsg = validateFaxNumberOnlyDigit(faxNumber.trim())

      if (errorMsg) {
        setErrorMessage(errorMsg)
        return
      }
    }

    const params = {
      associationId: netIdToEdit?.associationId,
      netId,
      emailAddress:
        netIdsForSelect.find((v) => v.netId === netId)?.emailAddress || "",
      faxNumber: faxNumber ? prepareFinalFaxNumber(faxNumber) : "",
      netIdRole: netIdsForSelect.find((n) => n.netId === netId).netIdRole,
    }

    if (
      netIdToEdit &&
      ["netId", "faxNumber"].every(
        (field) => params[field] === netIdToEdit[field],
      )
    ) {
      setErrorMessage("Neither NetID nor Fax Number has changed")
      return
    }

    if (
      !isWarning &&
      !isConfirmed &&
      netIdToEdit &&
      netIdToEdit?.faxNumber !== faxNumber
    ) {
      setIsWarning(true)
      return
    }

    onSave(params)
    setIsWarning(false)
  }

  const optionNetIds = netIdsForSelect
    .map((n) => ({
      value: n.netId,
      label: displayNetIdEmail(n.netId, n.emailAddress),
    }))
    .sort((a, b) => a.value.localeCompare(b.value))

  const isTakeConfirmation = !(!isWarning || !netIdToEdit)

  return (
    <div className="popup-overlay">
      <div
        className="popup"
        style={{ maxWidth: isTakeConfirmation ? "820px" : "450px" }}
      >
        {actionLoading ? (
          <div className="loading" style={{ padding: "20px" }}>
            In progress ...
          </div>
        ) : (
          <>
            <div className="checkbox-popup-header">
              <h3 className="popup-title">
                {netIdToEdit ? `Update` : `Add`} NetId
              </h3>
              <button
                type="button"
                onClick={onClose}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: 24,
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>

            {!isTakeConfirmation ? (
              <form
                className="popup-group"
                onSubmit={(e) => handleSubmit(e, false)}
              >
                <div className="form-group">
                  <label htmlFor="netId">
                    NetId: <span className="mandatory">*</span>
                  </label>

                  <Select
                    id="netId"
                    className="basic-single"
                    classNamePrefix="select"
                    value={optionNetIds.find(
                      (option) => option.value === netId,
                    )}
                    onChange={(selectedOption) =>
                      setNetId(selectedOption.value)
                    }
                    options={optionNetIds}
                    styles={customSelectStyles}
                    isSearchable
                    menuPortalTarget={document.body}
                  />

                  {/* <input
              type="text"
              id="netId"
              value={netId}
              onChange={(e) => {
                setNetId(e.target.value.trim())
                setErrorMessage("")
              }}
            /> */}
                </div>

                <div className="form-group">
                  <label htmlFor="netId">
                    Fax Number: <span className="mandatory"></span>
                  </label>
                  <input
                    type="text"
                    id="faxNumber"
                    value={faxNumber}
                    onChange={(e) => {
                      setFaxNumber(e.target.value)
                      setErrorMessage("")
                    }}
                  />
                </div>

                {errorMessage && (
                  <div className="error-message">{errorMessage}</div>
                )}

                <div className="popup-buttons">
                  <button
                    className="popup-button cancel"
                    type="button"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                  <button className="popup-button save" type="submit">
                    {actionLoading
                      ? `In progress ...`
                      : netIdToEdit
                        ? "Update"
                        : "Create"}
                  </button>
                </div>
              </form>
            ) : (
              <div>
                <div style={{ padding: "10px" }}>
                  <p>
                    Are you sure you want to update the fax number for the NetId
                    <strong> {netIdToEdit?.netId}</strong>?
                  </p>
                  <p>
                    Updating the fax number will permanently delete all existing
                    fax records from the NetId subfolders.
                  </p>
                  <p>
                    <TriangleAlert size={18} fill="yellow" stroke="black" style={{ marginRight: "5px", verticalAlign: "middle" }} />
                    This operation is irreversible and deleted data cannot be
                    recovered.
                  </p>
                </div>
                <div className="popup-buttons" style={{ padding: "10px" }}>
                  <button
                    type="button"
                    className="popup-button cancel"
                    onClick={() => setIsWarning(false)}
                  >
                    No
                  </button>
                  <button
                    type="submit"
                    className="popup-button save"
                    onClick={(e) => handleSubmit(e, true)}
                  >
                    Yes, Update
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

const DeleteConfirmationPopup = ({
  onConfirm,
  onCancel,
  actionLoading,
  netIdIdToDelete,
}) => (
  <div className="popup-overlay">
    <div className="popup" style={{ padding: "20px", maxWidth: "700px" }}>
      {actionLoading ? (
        <div>Processing...</div>
      ) : (
        <>
          {/* <h3>Confirm Deletion</h3> */}
          <p>
            Are you sure you want to delete the netId{" "}
            <strong>{netIdIdToDelete?.netId}?</strong>
          </p>
          <p>
            This action will permanently delete all associated subfolders from
            the NetId along with copied items.
          </p>
          <p>
            <TriangleAlert size={18} fill="yellow" stroke="black" style={{ marginRight: "5px", verticalAlign: "middle" }} />
            This operation is irreversible and data cannot be recovered once
            deleted.
          </p>
          <div className="popup-buttons">
            <button className="cancel" onClick={onCancel}>
              Cancel
            </button>
            <button className="delete" onClick={onConfirm}>
              Delete
            </button>
          </div>
        </>
      )}
    </div>
  </div>
)

export default NetIdToFaxNumberAssociation
